import { Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import React, { useCallback } from 'react'
import { mutualTheme } from '~/utils/theme'
import { PropsWithWizard } from '~/components/CreateAccountWizard'
import { Header, Content, Footer } from './components'

export type BaseCreateAccountWizardPageProps = {
  title: string,
  loading?: boolean,
  hideFooter?: boolean,
  removeSteps?: boolean,
  buttonLabel?: string,
  removeButton?: boolean,
  onContinue?: () => any,
  onBackPress?: () => any,
  shouldContinue?: boolean,
  manualCurrentPage?: number,
  removePreviousButton?: boolean,
  description: string | JSX.Element,
  onContinueButtonPress?: () => void
}

export type CreateAccountWizardPageProps = PropsWithWizard<BaseCreateAccountWizardPageProps>

const useStyles = makeStyles({
  container: {
    flex: 1,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: mutualTheme.spacing(4),
    [mutualTheme.breakpoints.down('md')]: {
      // width: '100vw',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 0
    }
  },
  innerContainer: {
    flexGrow: 1,
    maxWidth: 650,
    display: 'flex',
    flexDirection: 'column',
    [mutualTheme.breakpoints.down('md')]: {
      maxWidth: 300,
      height: '100%'
      // marginTop: mutualTheme.spacing(4)
    }
  },
  stepCounter: {
    color: mutualTheme.palette.textGray3.main
  },
  childrenContainer: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    [mutualTheme.breakpoints.down('md')]: {
      alignItems: 'center'
    }
  }
})

export const CreateAccountWizardPage: React.FC<CreateAccountWizardPageProps> = (props) => {
  const {
    title, description, initialPageReached, loading,
    onPrevPage, shouldContinue, buttonLabel, removeButton,
    onExit, onBackPress, children, onContinueButtonPress,
    removePreviousButton, hideFooter
  } = props

  const classes = useStyles()

  const goToPreviousPage = useCallback(() => {
    if (initialPageReached && onExit) {
      onExit()
      return
    }
    if (onBackPress) {
      onBackPress()
    }
    onPrevPage && onPrevPage()
  }, [onExit, initialPageReached, onBackPress, onPrevPage])

  const handleBack = useCallback(() => {
    goToPreviousPage()
  }, [goToPreviousPage])

  return (
    <Box className={classes.container}>
      <Box className={classes.innerContainer}>
        <Header
          handleBack={!removePreviousButton ? handleBack : undefined }
          {...props}
        />
        <Content
          title={title}
          loading={loading}
          buttonLabel={buttonLabel}
          description={description}
          removeButton={removeButton}
          shouldContinue={shouldContinue}
          onContinueButtonPress={onContinueButtonPress}
        >
          {children}
        </Content>
      </Box>
      {!hideFooter && <Footer />}
    </Box>
  )
}

CreateAccountWizardPage.defaultProps = {
  shouldContinue: true
}
